var map = {
	"./CarouselAPO": 3728,
	"./CarouselAPO.js": 3728,
	"./CarouselCustomers": 2461,
	"./CarouselCustomers.js": 2461,
	"./CarouselImage": 6309,
	"./CarouselImage.js": 6309,
	"./Contactform": 1898,
	"./Contactform.js": 1898,
	"./GradientDivider": 5817,
	"./GradientDivider.js": 5817,
	"./Gridgallery": 8729,
	"./Gridgallery.css": 8955,
	"./Gridgallery.js": 8729,
	"./Jumbotron": 4953,
	"./Jumbotron.css": 8854,
	"./Jumbotron.js": 4953,
	"./Logo": 7986,
	"./Logo.js": 7986,
	"./MJCard": 904,
	"./MJCard.js": 904,
	"./Menu": 2162,
	"./Menu.js": 2162,
	"./Singleoffer": 6951,
	"./Singleoffer.css": 811,
	"./Singleoffer.js": 6951,
	"./car1.png": 5830,
	"./images/PLC.jpg": 8947,
	"./images/automa.webp": 6,
	"./images/car1.avif": 7770,
	"./images/car1.png": 9498,
	"./images/car1.webp": 9279,
	"./images/car2.avif": 5370,
	"./images/car2.webp": 7139,
	"./images/car3.avif": 7158,
	"./images/car3.webp": 1254,
	"./images/carlogo.jpg": 358,
	"./images/carlogo.webp": 494,
	"./images/carlogo2.webp": 4445,
	"./images/carlogo3.webp": 8992,
	"./images/carlogo4.webp": 8306,
	"./images/circuit.svg": 435,
	"./images/cog.png": 936,
	"./images/cog.svg": 7113,
	"./images/customers/bieluch.webp": 616,
	"./images/customers/cewar.webp": 1173,
	"./images/customers/edwood.webp": 9445,
	"./images/customers/erkado.webp": 3813,
	"./images/customers/imageData": 108,
	"./images/customers/imageData.json": 108,
	"./images/customers/kps.png": 8670,
	"./images/customers/mardom.webp": 8830,
	"./images/customers/mebloster.png": 8100,
	"./images/customers/mlmeble.webp": 69,
	"./images/customers/parys.png": 1838,
	"./images/customers/witraz.png": 4091,
	"./images/customers/wojcik.png": 9899,
	"./images/icons/facebook.svg": 7919,
	"./images/logistic.svg": 2545,
	"./images/logo-white.svg": 1493,
	"./images/logo22.png": 3767,
	"./images/logos/beckhoff.png": 4011,
	"./images/logos/finder.png": 5999,
	"./images/logos/hflogo.png": 4538,
	"./images/logos/imageData": 4194,
	"./images/logos/imageData.json": 4194,
	"./images/logos/kubler.png": 7048,
	"./images/logos/lenze.png": 208,
	"./images/logos/ls.png": 40,
	"./images/logos/nord.png": 661,
	"./images/logos/omron.png": 2513,
	"./images/micro.png": 2361,
	"./images/offerimages/cewar.webp": 6161,
	"./images/offerimages/control.png": 4680,
	"./images/offerimages/control.webp": 9291,
	"./images/offerimages/drive.png": 8819,
	"./images/offerimages/drive.webp": 3933,
	"./images/offerimages/electric.png": 419,
	"./images/offerimages/electric.webp": 2962,
	"./images/offerimages/hydraulics.png": 3565,
	"./images/offerimages/hydraulics.webp": 5079,
	"./images/offerimages/inverter.png": 9884,
	"./images/offerimages/inverter.webp": 8801,
	"./images/offerimages/pneumatics.png": 9801,
	"./images/offerimages/pneumatics.webp": 8772,
	"./images/offerimages/robotics.webp": 7646,
	"./images/offerimages/safety.png": 8176,
	"./images/offerimages/safety.webp": 7759,
	"./images/offerimages/sensors.png": 4979,
	"./images/offerimages/sensors.webp": 2184,
	"./images/overlay.png": 8666,
	"./images/path316.svg": 7567,
	"./images/robot.png": 3599,
	"./images/robot.svg": 8528,
	"./images/robotic.jpg": 3234,
	"./images/robotic.webp": 6300,
	"./images/shelf.jpeg": 891,
	"./images/shelf.webp": 5619,
	"./logo.png": 161,
	"./logo.svg": 8798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 744;